import { DiagramRole } from "../types/enums";

// Persisted ids run in the opposite direction to privilege. Match the server's
// explicit hierarchy; an unknown effective role never grants a capability.
const roleRank: Record<DiagramRole, number> = {
  [DiagramRole.Viewer]: 0,
  [DiagramRole.Commenter]: 1,
  [DiagramRole.Editor]: 2,
  [DiagramRole.Owner]: 3,
};

export function getBoardPermissions(role: number | null | undefined, preview = false) {
  const rank = role == null ? -1 : (roleRank[role as DiagramRole] ?? -1);
  const canRestore = rank >= roleRank[DiagramRole.Editor];
  return { canEditDocument: canRestore && !preview, canRestore };
}
